import { tv } from '@change/ds-utils';

export const photoUploadSection = tv({
	base: 'flex flex-col items-start gap-3',
});

export const photoUploadLabel = tv({
	base: 'flex flex-col gap-3',
});

export const photoPlaceholder = tv({
	base: 'bg-fill-weaker flex h-[120px] w-[120px] items-center justify-center rounded-full',
});

export const photoUploadControls = tv({
	base: 'flex flex-col items-center gap-3',
});
